export default __webpack_public_path__ + "static/media/gallery_05.6a0e7d27.jpg";